// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".green{background:#c8e9c3}.yellow{background:#e9dfc3}.red{background:#e9c3c3}.user_name{background:#f09726;border-radius:25px;color:#fff;padding:0 26px}.orange{color:#f09726}.square{border-radius:3px;height:12px;margin:0 10px;width:12px}.grid{align-items:center;display:flex}.placing{margin:0 10px}.filter-field{padding:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
